import { notifications } from '@mantine/notifications';
import { useApi } from 'api/api-context';
import HierarchyForm, { HierarchyFormData } from 'components/forms/hierarchy/HierarchyForm';
import RequireGlobalPermissionPage from 'components/permissions/RequireGlobalPermissionPage';
import panic from 'errors/panic';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { useNavigate } from 'react-router-dom';
import { EDIT_HIERARCHY_PAGE_PATH, HIERARCHIES_PAGE_PATH } from 'routes/paths';
import { SUCCESS_NOTIFICATION_COLOR } from 'utils/constants';
import { IconPlus } from '@tabler/icons-react';

/** Creates a non-default hierarchy. */
export default function AddHierarchyPage() {
  const { getAction } = useApi();
  const navigate = useNavigate();

  /** Creates the hierarchy and navigates to its detail. */
  const onSubmit = ({ hierarchyName, levels, organizationIds }: HierarchyFormData) =>
    getAction('HierarchyCreate')({
      payload: { hierarchyName, levels, organizationIds: organizationIds.map(Number) },
    })
      .then(({ hierarchyId }) => {
        notifications.show({
          title: 'Hierarchia bola vytvorená',
          message: `Hierarchia ${hierarchyName} bola úspešne vytvorená.`,
          color: SUCCESS_NOTIFICATION_COLOR,
        });
        navigate(EDIT_HIERARCHY_PAGE_PATH.insert({ hierarchyId }));
      })
      .catch(panic);

  return (
    <RequireGlobalPermissionPage permission="manage-hierarchies">
      <DashboardLayout
        title="Pridanie novej hierarchie"
        breadcrumbs={[{ title: 'Hierarchie', link: HIERARCHIES_PAGE_PATH.original }, { title: 'Pridanie' }]}
      >
        <HierarchyForm
          onSubmit={onSubmit}
          primaryButtonText="Vytvoriť"
          primaryIcon={<IconPlus stroke="1.5" size={24} />}
        />
      </DashboardLayout>
    </RequireGlobalPermissionPage>
  );
}
